import React from 'react';

import { TitlePage } from './styles';

const PageTitle: React.FC = ({ children }) => {
  return (
    <TitlePage>
      <h1>{children}</h1>
    </TitlePage>
  );
};

export default PageTitle;
